import { Pipe, PipeTransform } from '@angular/core';

import { I18nService } from './i18n.service';
import { TranslationKey, TranslationParams } from './translations';

@Pipe({
  name: 't',
  standalone: true,
  pure: false
})
export class I18nPipe implements PipeTransform {
  constructor(private readonly i18n: I18nService) {}

  transform(key: TranslationKey, params?: TranslationParams): string {
    return this.i18n.t(key, params);
  }
}
